import { createFileRoute } from "@tanstack/react-router"
import { AccountPage } from "@/app"

export const Route = createFileRoute("/(user)/(tenant)/account")({
  component: RouteComponent,
})

function RouteComponent() {
  return <AccountPage />
}
